import { render, staticRenderFns } from "./leaderCard.vue?vue&type=template&id=0e84b86b&scoped=true"
import script from "./leaderCard.vue?vue&type=script&lang=js"
export * from "./leaderCard.vue?vue&type=script&lang=js"
import style0 from "./leaderCard.vue?vue&type=style&index=0&id=0e84b86b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e84b86b",
  null
  
)

export default component.exports